import RequestBuilder from 'Resources/RequestBuilder';
import T from 'Components/Helpers/translate';
import { MultiSelect } from 'App/components/ListView/ListViewRenderHelpers';
import NotificationService from 'App/babel/NotificationService';
import getAngularModule from 'App/babel/angularHelpers/getAngularModule';
import openModal from 'App/services/Modal';

export default async function inactivateContacts(
	requestBuilder: RequestBuilder,
	entity: string,
	multiSelect: MultiSelect,
	customerId: number
) {
	const AppService = getAngularModule('AppService');
	const MultiActions = getAngularModule('MultiActions');
	const userEmail = AppService.getSelf().email;

	const contactCount = multiSelect.selected;
	const displayAmount =
		contactCount > 1
			? `${contactCount} ${T('default.contacts').toLowerCase()}`
			: `1 ${T('default.contact').toLowerCase()}`;

	const title =
		contactCount > 1
			? `${T('AccountDeactivationModal.titleMany', { displayAmount })} ${T('contacts').toLowerCase()} ${T(
					'default.inactivePlural'
			  ).toLowerCase()}?`
			: T('AccountDeactivationModal.title', { companyName: displayAmount });

	// Open the Alert modal with email confirmation
	const confirmed = await new Promise<boolean>(resolve => {
		openModal('Alert', {
			title: title,
			confirmButtonText: `${T('integration.inactivate')} ${displayAmount}`,
			cancelButtonText: T('default.cancel'),
			confirmationMode: 'text',
			confirmText: userEmail,
			onClose: (result?: boolean) => {
				resolve(result || false);
			}
		});
	});

	if (!confirmed) {
		return;
	}

	const properties = [{ name: 'Active', value: '0' }];

	try {
		const response = await MultiActions.customer(customerId).updateContact(
			entity,
			multiSelect.selected,
			properties,
			requestBuilder.build(),
			{}
		);

		// If we selected 10 or fewer, update them now
		if (multiSelect.selected <= 10) {
			// Wait for index then show notification
			setTimeout(() => {
				NotificationService.add({
					style: NotificationService.style.SUCCESS,
					icon: 'check',
					title: 'default.saved',
					body: T('multi.inactivateContacts.done', { count: multiSelect.selected })
				});
			}, 2000);
		} else {
			// More than 10 - a job will be created
			NotificationService.add({
				style: NotificationService.style.SUCCESS,
				icon: 'check',
				title: 'default.saved',
				body: T('updateQued.inactivateContacts')
			});
		}

		return response;
	} catch (e) {
		NotificationService.add({
			style: NotificationService.style.ERROR,
			icon: 'times',
			title: 'default.error',
			body: e
		});
		throw e;
	}
}
